import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DialogComponent as SyncfusionDialogComponent } from '@syncfusion/ej2-angular-popups';
import { ClientDTO, FilterDTO, FilterOperator, ParkerGroup, ParkingSubscriptionClient, ParkingSubscriptionDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { DropDownConstantsFactory } from 'src/app/base/shared/syncfusion/dropdown-constants-factory';
import { ClientService } from 'src/app/base/services/client/client.service';
import { ListBoxComponent, ListBoxModule, DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ChipListComponent, ChipModel, ChipListModule } from '@syncfusion/ej2-angular-buttons';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ParkerFilterField } from './parker-filter-field';
import { EnumTranslationService } from 'src/app/base/services/enum-translation.service';
import { YesNoGroupButtonComponent } from '../../../../base/shared/yes-no-group-button/yes-no-group-button.component';

import { DialogModule } from '@syncfusion/ej2-angular-popups';

@Component({
    selector: 'app-parker-filter',
    templateUrl: './parker-filter.component.html',
    styleUrls: ['./parker-filter.component.scss'],
    imports: [ChipListModule, DialogModule, ListBoxModule, ReactiveFormsModule, DropDownListModule, YesNoGroupButtonComponent, TranslateModule]
})
export class ParkerFilterComponent implements OnInit, AfterViewChecked {

  @ViewChild('filterDialog') public filterDialog: SyncfusionDialogComponent;
  @ViewChild("fieldsListBox") public fieldsListBox: ListBoxComponent;
  @ViewChild("filterChipList") public filterChipList: ChipListComponent

  @Output() public filterUpdated = new EventEmitter<FilterDTO[]>();

  constructor(private fb: UntypedFormBuilder,
    private parkingSubscriptionClient: ParkingSubscriptionClient,
    private clientService: ClientService,
    private translateService: TranslateService,
    private enumTranslateService: EnumTranslationService,
    private cdr: ChangeDetectorRef,) {
  }

  private filters: FilterDTO[] = [];

  public filterFieldList: ParkerFilterField[] = [
    {
      displayName: "Group", getValueText: (value) => {
        return value;
      },
      i18nLabel: 'i18n.domain.parker-administration.overview.fields.group'
    },
    { displayName: "CostCenter", filterOperator: FilterOperator.Contains, getValueText: (value) => value, i18nLabel: 'i18n.domain.parker-administration.overview.fields.cost-center' },
    { displayName: "Title", filterOperator: FilterOperator.Contains, getValueText: (value) => value, i18nLabel: 'i18n.domain.parker-administration.overview.fields.title' },
    { displayName: "Workplace", filterOperator: FilterOperator.Contains, getValueText: (value) => value, i18nLabel: 'i18n.domain.parker-administration.overview.fields.workplace' },
    { displayName: "EmploymentPercentage", filterOperator: FilterOperator.Equal, getValueText: (value) => value, i18nLabel: 'i18n.domain.parker-administration.overview.fields.employment-percentage' },
    { displayName: "IsLinked", getValueText: (value) => value === true ? this.translateService.instant("i18n.shared.yes") : this.translateService.instant("i18n.shared.no") },
    { displayName: "Active", getValueText: (value) => value === true ? this.translateService.instant("i18n.shared.yes") : this.translateService.instant("i18n.shared.no"), i18nLabel: 'i18n.domain.parker-administration.overview.fields.active' },
    { displayName: "Billing", getValueText: (value) => value === true ? this.translateService.instant("i18n.shared.yes") : this.translateService.instant("i18n.shared.no"), i18nLabel: 'i18n.domain.parker-administration.overview.fields.billing' },
    { displayName: "HasSubscriptions", getValueText: (value) => value === true ? this.translateService.instant("i18n.shared.yes") : this.translateService.instant("i18n.shared.no") },
    {
      displayName: "Subscription", getValueText: (value) => {
        var sub = this.subscriptionsDropdownValues.find(s => s.id === value);
        if (sub) {
          return sub.name;
        }
        return value;
      }
    }
  ];

  public fieldList: object = { text: "displayName", value: "displayName" };

  public dropdownSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();
  public enumDropdownSettings = DropDownConstantsFactory.createEnumDropdownSettings();
  public groupTypes = this.enumTranslateService.translateEnum(ParkerGroup, 'i18n.domain.parker-administration.enums.group-type.', true);

  public groups: string[] = [];

  public filterForm: UntypedFormGroup

  public subscriptionsDropdownValues = [];
  public chips: ChipModel[] = [];
  public client: ClientDTO = this.clientService.selectedClient;

  ngOnInit() {
    this.filterForm = this.fb.group({
      Group: [null],
      CostCenter: [null],
      Title: [null],
      Workplace: [null],
      EmploymentPercentage: [null],
      IsLinked: [null],
      Active: [null],
      Billing: [null],
      HasSubscriptions: [null],
      Subscription: [null],
      Custom1: [null],
      Custom2: [null],
      Custom3: [null],
      Custom4: [null],
      Custom5: [null],
      Custom6: [null],
      Custom7: [null],
      Custom8: [null],
      Custom9: [null]
    });

    if (this.client.custom1Name) {
      this.filterFieldList.push({ filterField: "Custom1", displayName: this.client.custom1Name, filterOperator: FilterOperator.Equal, getValueText: (value) => value });
    }

    if (this.client.custom2Name) {
      this.filterFieldList.push({ filterField: "Custom2", displayName: this.client.custom2Name, filterOperator: FilterOperator.Equal, getValueText: (value) => value });
    }

    if (this.client.custom3Name) {
      this.filterFieldList.push({ filterField: "Custom3", displayName: this.client.custom3Name, filterOperator: FilterOperator.Equal, getValueText: (value) => value });
    }

    if (this.client.custom4Name) {
      this.filterFieldList.push({ filterField: "Custom4", displayName: this.client.custom4Name, filterOperator: FilterOperator.Equal, getValueText: (value) => value });
    }

    if (this.client.custom5Name) {
      this.filterFieldList.push({ filterField: "Custom5", displayName: this.client.custom5Name, filterOperator: FilterOperator.Equal, getValueText: (value) => value });
    }

    if (this.client.custom6Name) {
      this.filterFieldList.push({ filterField: "Custom6", displayName: this.client.custom6Name, filterOperator: FilterOperator.Equal, getValueText: (value) => value });
    }

    if (this.client.custom7Name) {
      this.filterFieldList.push({ filterField: "Custom7", displayName: this.client.custom7Name, filterOperator: FilterOperator.Equal, getValueText: (value) => value });
    }

    if (this.client.custom8Name) {
      this.filterFieldList.push({ filterField: "Custom8", displayName: this.client.custom8Name, filterOperator: FilterOperator.Equal, getValueText: (value) => value });
    }

    if (this.client.custom9Name) {
      this.filterFieldList.push({ filterField: "Custom9", displayName: this.client.custom9Name, filterOperator: FilterOperator.Equal, getValueText: (value) => value });
    }

    this.loadSubscriptionDropdown();

    this.handleFilterAssignmentInForm();

  }

  public ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  private handleFilterAssignmentInForm() {
    this.filterForm.valueChanges.subscribe(() => {
      let chips = [];
      this.filters = [];
      this.filterFieldList.forEach(field => {
        if (this.filterForm.controls[field.filterField ?? field.displayName].value != null) {
          chips.push(this.getChip(field, this.filterForm.controls[field.filterField ?? field.displayName].value));

          this.filters.push(new FilterDTO({
            isComplex: false,
            field: field.filterField ?? field.displayName,
            operator: field.filterOperator ?? FilterOperator.Equal,
            value: this.filterForm.controls[field.filterField ?? field.displayName].value,
          }));
        }
      });
      this.chips = chips;
    });
  }

  private loadSubscriptionDropdown() {
    const filters = [
      new FilterDTO({
        isComplex: false,
        field: 'Active',
        operator: FilterOperator.Equal,
        value: 'true'
      })
    ];
    if (this.clientService.selectedClient) {
      this.parkingSubscriptionClient.searchParkingSubscriptions(this.clientService.selectedClient.id, filters, 0, 0, 'Name', SortDirection.Ascending)
        .subscribe(res => {
          this.subscriptionsDropdownValues = res.items.map(s => {
            let label = s.name;
            if (s.description) {
              label += ', ' + s.description;
            }
            return { name: label, id: s.id };
          });
        });
    }
  }

  public openFilterDialog(): void {
    this.filterDialog.show();
  }

  public applyFilter() {
    this.filterUpdated.emit(this.filters);
    this.filterDialog.hide();
  }

  public closeFilterDialog() {
    this.filterDialog.hide();
  }

  public isTheFieldSelected(fieldName: string): boolean {
    return this.fieldsListBox?.value?.findIndex(v => v === fieldName) >= 0;
  }

  public hasFilter(fieldName: string): boolean {
    return this.chips.findIndex(f => f.value == fieldName) > -1;
  }

  private getChip(field: ParkerFilterField, value: any): ChipModel {
    var text = field.getValueText(value);
    return { text: (field.i18nLabel ? this.translateService.instant(field.i18nLabel) : field.displayName) + ":" + text, value: field.filterField ?? field.displayName };
  }

  public chipDeleted(chipData: any) {
    if (chipData) {
      var index = this.filters.findIndex(f => f.field === chipData.data.value);
      if (index >= 0) {
        this.filters.splice(index, 1);
        if (this.chips.findIndex(c => c.value === chipData.data.value) > -1) {
          this.chips.splice(this.chips.findIndex(c => c.value === chipData.data.value), 1);
        }

        this.filterForm.controls[chipData.data.value].setValue(null, { emitEvent: false });
        this.filterUpdated.emit(this.filters);
      }
    }
  }
}
